import { cn } from "@/common/utils/css.utils";
import { ComponentProps } from "react";
import { Body } from "@/ui/typography/Body";

export const HorizontalSplitter = (props: ComponentProps<"hr">) => {
  const { className, ...rest } = props;
  return <hr {...rest} className={cn("border-t border-grey-300", className)} />;
};

export const HorizontalSplitterWithText = ({
  text,
  ...props
}: ComponentProps<"span"> & { text: string }) => {
  const { className, ...rest } = props;
  return (
    <span {...rest} className={cn("flex items-center space-x-4", className)}>
      <HorizontalSplitter className="flex-1" />
      <Body>{text}</Body>
      <HorizontalSplitter className="flex-1" />
    </span>
  );
};
